/**
 * Optional CSV file base name (without .csv).
 * For Media Devoted | Created By Ciro Autiero
 */

import { forwardRef } from 'react';

import { Input } from '@/components/ui';

export interface CsvExportDownloadNameFieldProps {
  value: string;
  disabled: boolean;
  onChange: (v: string) => void;
}

export const CsvExportDownloadNameField = forwardRef<
  HTMLInputElement,
  CsvExportDownloadNameFieldProps
>(({ value, disabled, onChange }, ref) => (
  <section className="space-y-1.5">
    <label
      htmlFor="csv-export-download-name"
      className="text-xs font-semibold uppercase tracking-wide text-muted-foreground"
    >
      File name (optional)
    </label>
    <Input
      ref={ref}
      id="csv-export-download-name"
      name="csvExportDownloadFilename"
      placeholder="e.g. march-phones (saved with template if you save one)"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      onBlur={(e) => {
        const v = e.target.value;
        if (v !== value) onChange(v);
      }}
      className="h-9 text-sm"
      autoComplete="off"
    />
    <p className="text-[11px] leading-snug text-muted-foreground">
      .csv is added automatically. Leave blank for the default name.
    </p>
  </section>
));

CsvExportDownloadNameField.displayName = 'CsvExportDownloadNameField';
